export default __webpack_public_path__ + "static/media/2-produtos.79059d79.svg";